var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormDescriptionPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_6842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2.7998V5.1998H5.2V2.7998H2ZM6.8 2.7998V3.5998H16.4V2.7998H6.8ZM2.8 3.5998H4.4V4.3998H2.8V3.5998ZM6.8 4.3998V5.1998H11.6V4.3998H6.8ZM6.8 5.9998V6.7998H18V5.9998H6.8ZM6.8 7.5998V8.3998H14.8V7.5998H6.8ZM2 11.5998V13.9998H5.2V11.5998H2ZM6.8 11.5998V12.3998H16.4V11.5998H6.8ZM2.8 12.3998H4.4V13.1998H2.8V12.3998ZM6.8 13.1998V13.9998H11.6V13.1998H6.8ZM6.8 14.7998V15.5998H18V14.7998H6.8ZM6.8 16.3998V17.1998H14.8V16.3998H6.8Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_6842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormDescriptionPlaceholder);
export default __webpack_public_path__ + "static/media/form-description-placeholder.6b8c3f10aeb634e23584d37dfb8994fb.svg";
export { ForwardRef as ReactComponent };